import httpManager from "@/app/shared/utils/httpManager";

/**
 * Registra un nuevo alias "Enviar como" para un canal de correo.
 *
 * @param {number} channelCustomerId - ID del identificador de canal.
 * @param {Object} data - Datos del alias.
 * @param {string} data.email - Dirección de correo electrónico del alias.
 * @returns {Promise<Object>} Datos del alias registrado.
 */
export default async function (channelCustomerId, data) {
  const response = await httpManager.post(
    `/channels/channel-customer/${channelCustomerId}/send-as-aliases/`,
    data
  );
  return response?.data;
}
